import styled from "styled-components";

export const NavBarContainer = styled.div`
  .navbar {
    background-color: #fff;
    width: 100%;
    padding: 0;
    .nav-wrapper {
      /* box-shadow: inset 0 -15px 21px -15px #a29f9f; */
      width: 100%;
      padding: 0 clamp(60px, 4.688vw, 90px);
    }
  }
  .navbar-logo img {
    cursor: pointer;
    max-width: 255px;
  }
  .navbar-container {
    display: grid;
    /* height: 81px; */
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    /* padding: 0 clamp(20px, 20px, 84px); */
    grid-template-columns: auto 1fr auto;
    align-items: center;
    max-width: 1752px;
    margin: 0 auto;
  }
  .nav-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    list-style: none;
    text-align: center;
    justify-content: start;
    margin-bottom: 0;
    height: 100%;
    margin-left: 15px;
    gap: 0 clamp(15px, 2.292vw, 44px);
  }
  .toggle {
    .nav-link {
      display: flex;
      flex-direction: column;
      text-transform: capitalize;
      justify-content: center;
      align-items: flex-end;
    }
    &:hover {
      border-bottom: none;
      color: #0a5587;
      border-bottom: 2px solid transparent;
    }
  }
  .nav-item {
    cursor: pointer;
    border-bottom: 4px solid transparent;
    position: relative;
    a {
      font-size: 13px;
      /* line-height: 24px; */
      color: rgba(17, 17, 17, 0.3);
      text-decoration: none;
      font-family: "latosemibold";
    }
    &.active {
      border-color: #0a5587;
      padding: 17px 0;
      a {
        color: #0a5587;
      }
    }
  }
  .nav-item:hover {
    a {
      color: #0a5587;
    }
  }
  .nav-link:hover {
    color: #0a5587;
  }
  .nav-link {
    color: #0a5587;
    display: flex !important;
    align-items: center;
    text-decoration: none;
    padding: 0.5rem 15px !important;
    height: 100%;
    font-size: 14px;
    text-align: left;
    font-family: "latoregular";
    line-height: 18px;
    text-transform: uppercase;
    border-bottom: 4px solid transparent;
    justify-content: space-between;
    &.user-name {
      font-size: 20px;
      line-height: 24px;
      color: #111111;
      text-transform: capitalize;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;

      .upper-name {
        display: flex;
        align-items: center;
        gap: 4px;
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100px;
          min-width: 89px;
          font-size: 14px;
        }
      }
      > span {
        color: rgba(17, 17, 17, 0.4);
        font-size: 13px;
        line-height: 17px;
      }
    }
  }

  .right-menu {
    margin-bottom: 0;
    margin-right: 50px;
    display: flex;
    height: 100%;
    align-items: center;
    list-style: none;
  }
`;
export const UserDropDown = styled.div`
  /* :before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: #fff;
    position: absolute;
    z-index: 3;
    bottom: -8px;
    transform: rotateZ(45deg);
    right: 9px;
    border-left: solid 1px #87cdf1;
    border-top: solid 1px #87cdf1;
  } */
`;
